import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/ai.png'


const _withScopeId = n => (_pushScopeId("data-v-12d6fb56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-content" }
const _hoisted_2 = {
  key: 0,
  class: "image-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "animated",
  src: _imports_0
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "profile-image-container"
}
const _hoisted_6 = ["src", "alt", "title"]
const _hoisted_7 = { class: "markdown-wrapper" }
const _hoisted_8 = ["innerHTML"]

import type { ChatMessage } from '@/composables/aiChatFunctions';
import type { AICollabMessage } from '@/types';
import { marked } from 'marked';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'aiMessageDisplayer',
  props: {
    message: {},
    mine: { type: Boolean },
    collab: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const formattedContent = computed(() => {
    marked.use({
        breaks:true,
        gfm: true,
    });
    return marked.parse(props.message.content);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'ai': _ctx.message.type === 'ai', 'human': _ctx.message.type === 'human', 'other_user': !_ctx.mine && _ctx.collab }, "message-container"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.message.type === 'ai')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.message.type === 'human' && !_ctx.mine && _ctx.collab)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createElementVNode("img", {
              referrerpolicy: "no-referrer",
              class: "profile-image",
              src: _ctx.message.from?.picture,
              alt: _ctx.message.from?.name,
              title: _ctx.message.from?.name
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          innerHTML: formattedContent.value,
          class: "markdown-content"
        }, null, 8, _hoisted_8)
      ])
    ])
  ], 2))
}
}

})